import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { getListingLabel } from './helpers';

export default function DealListingSelect({ listings, value, onChange }) {
  if (!listings) {
    return null;
  }

  let label;
  if (listings[0].type == 'LotListing') {
    label = 'Lot';
  } else if (listings[0].type == 'CondoListing') {
    label = 'Condo';
  } else {
    label = 'Lease Space';
  }

  return (
    <div className="form form-horizontal">
      <ManagedFormGroup
        includeBlank
        label={label}
        required
        type="select"
        value={value && value.id}
        onValueChange={id => onChange(listings.find(listing => listing.id.toString() === id))}
      >
        {listings.map(listing => (
          <option key={listing.id} value={listing.id}>
            {getListingLabel(listing)}
          </option>
        ))}
      </ManagedFormGroup>
    </div>
  );
}

DealListingSelect.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({
    address2: PropTypes.string,
    id: PropTypes.number.isRequired,
    number: PropTypes.string,
  })),
  value: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  onChange: PropTypes.func.isRequired,
};
